// API utility functions for Kerry M Holloway Insurance Agency

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Submit a quote request
 */
export const submitQuoteRequest = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/api/quotes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Failed to submit quote request');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Submit a contact form message
 */
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/api/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Failed to submit contact form');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get all services
 */
export const getServices = async () => {
  try {
    const response = await fetch(`${API_URL}/api/services`);

    if (!response.ok) {
      throw new Error('Failed to fetch services');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

const authFetch = (path, options = {}) =>
  fetch(`${API_URL}${path}`, { credentials: 'include', ...options });

export const exchangeSession = async (sessionId) => {
  const response = await authFetch('/api/auth/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId }),
  });
  if (!response.ok) throw new Error('Session exchange failed');
  return response.json();
};

export const getCurrentUser = async () => {
  const response = await authFetch('/api/auth/me');
  if (!response.ok) throw new Error('Not authenticated');
  return response.json();
};

export const logout = () => authFetch('/api/auth/logout', { method: 'POST' });

export const getLeads = async () => {
  const response = await authFetch('/api/admin/leads');
  if (response.status === 401) throw new Error('unauthenticated');
  if (response.status === 403) throw new Error('forbidden');
  if (!response.ok) throw new Error('Failed to load leads');
  return response.json();
};
